import { EventEmitter, Injectable } from '@angular/core';
import { Event, NavigationEnd, Router } from '@angular/router';
import { BehaviorSubject, Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { AppConfigService } from 'src/app/app-config/app-config.service';

@Injectable({
  providedIn: 'root'
})
export class AssetTreeService {
  private showAssetTreeNav = new BehaviorSubject<any>(true);
  private devicesDataChanged = new BehaviorSubject<boolean>(false);
  private _devicesData = {};
  private _sideNavOpen = false;
  private _orgData = {};
  private _selectedOrgName;
  private _selectedSiteName;

  constructor(private http:HttpClient,
    private appConfigService:AppConfigService) { }

  set devicesData(data: any) {
    this._devicesData = data;
  }
  
  get sideNavOpen() {
    return this._sideNavOpen;
  }

  set sideNavOpen(data: any) {
    this._sideNavOpen = data;
  }
  
  get devicesData() {
    return this._devicesData;
  }

  set orgData(data: any) {
    this._orgData = data;
  }
  
  get orgData() {
    return this._orgData;
  }

  set selectedOrgName(data: any) {
    this._selectedOrgName = data;
  }
  
  get selectedOrgName() {
    return this._selectedOrgName;
  }

  set selectedSiteName(data: any) {
    this._selectedSiteName = data;
  }
  
  get selectedSiteName() {
    return this._selectedSiteName;
  }
  
  public getDevicesDataChanged(): Observable<boolean> {
    return this.devicesDataChanged.asObservable();
  }

  setDevicesDataChanged = (val: any) => {
    return this.devicesDataChanged.next(val);
  }

  public getShowAssetTreeNav(): Observable<boolean> {
    return this.showAssetTreeNav.asObservable();
  }

  setShowAssetTreeNav = (val: any) => {
    return this.showAssetTreeNav.next(val);
  }

  getOrganizationSiteData(){
    return this.http.get(this.appConfigService.getConfig().apiBaseUrl + 'AssetTree');
  }

  getDevicesByOrgId(orgId, orgFlag){
    return this.http.get(this.appConfigService.getConfig().apiBaseUrl + 'Devices/'+orgId+'?isDefaultOrg='+orgFlag);
  }

}